module.exports = "<div class=\"jumbotron wizard-bg-highlight\"> <div class=container> <div class=ff-icon-container> <div> <span class=\"fa-stack fa-6x\"> <i class=\"fa fa-circle fa-stack-2x\"></i> <i class=\"fa fa-hand-peace-o fa-stack-1x fa-inverse\"></i> </span> </div> <div class=ff-icon-body> <h1>Welcome to Freifunk!</h1> <p translate>description</p> <p class=small translate>freifunk</p> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home.html
// module id = 50
// module chunks = 0